// src/components/Section6Matrix.js
//
// SECTION 540 (Bob, on the 2026-09-30 call: Burkart "wants access to the section 6 settlements"; "lets make a matrix for
// full viewership"). Every national round side by side - moratorium, wages, lump sums, COLA, health and welfare,
// vacation, holidays, work rules - read off the agreements themselves (all pages of all six rounds; OCR where the PDF is
// a scan, and marked so). src\data\section6Terms.json is the extraction; data\YCP_SECTION6_TERMS_MATRIX.md its record.
// Open to everyone who reads the national agreements (ruling 263). A cell opens to the exact words and page.
import React, { useState } from 'react';
import S6 from '../data/section6Terms.json';
import { SlidesButton } from './SlideDeck';   // ruling 311: the rounds as slides
import { section6Deck } from '../data/slideDecks';
import { activate } from '../data/a11yActivate';   // pass 2: role, tabIndex and Enter/Space from one tested helper

const C = { line: '#2E4A6B', dim: '#8AA4BF', accent: '#E8A020', text: '#DCE7F2', head: '#10233A', ok: '#5FB878' };

export default function Section6Matrix() {
  const [open, setOpen] = useState(false);
  const [cell, setCell] = useState(null);
  const rounds = S6.rounds || [];
  return (
    <div style={{ marginTop: 12 }}>
      <button className="btn btn-secondary btn-sm" onClick={() => setOpen(!open)}>{open ? 'Hide the terms, round by round' : 'The terms, round by round - every Section 6 settlement side by side'}</button>
      <span style={{ marginLeft: 8 }}><SlidesButton build={() => section6Deck(S6)} /></span>
      {open ? (
        <div style={{ marginTop: 10 }}>
          <div style={{ fontSize: 11, color: C.dim, marginBottom: 8 }}>
            Read off the agreements themselves, every page. Most of these PDFs are scans: a cell marked OCR was read from the scanned image - check the page before you quote it. Click a cell for the agreement's own words and page.
          </div>
          <div style={{ overflowX: 'auto', border: '1px solid ' + C.line }}>
            <table style={{ borderCollapse: 'collapse', fontSize: 12, minWidth: 900 }}>
              <thead><tr>
                <th style={{ textAlign: 'left', padding: '6px 8px', background: C.head, color: C.dim, position: 'sticky', left: 0 }}>Term</th>
                {rounds.map(r => <th key={r.key} style={{ textAlign: 'left', padding: '6px 8px', background: C.head, color: r.tentative ? C.accent : C.text, minWidth: 170 }}>{r.year}{r.tentative ? ' (TENTATIVE)' : ''}</th>)}
              </tr></thead>
              <tbody>{(S6.terms || []).map(t => (
                <tr key={t.term}>
                  <td style={{ padding: '6px 8px', borderTop: '1px solid ' + C.line, color: C.text, fontWeight: 700, background: '#0B1626', position: 'sticky', left: 0, verticalAlign: 'top' }}>{t.term}</td>
                  {rounds.map(r => {
                    const c = (t.cells || {})[r.key];
                    const none = !c || c.status === 'NOT STATED';
                    return (
                      <td key={r.key} {...activate(() => !none && setCell({ term: t.term, round: r, c }))}
                        style={{ padding: '6px 8px', borderTop: '1px solid ' + C.line, verticalAlign: 'top', color: none ? C.dim : C.text, cursor: none ? 'default' : 'pointer' }}>
                        {none ? 'Not stated' : String(c.value).split(' | ').map((v, i) => <div key={i} style={{ marginBottom: 2 }}>{v}</div>)}
                        {!none ? <div style={{ fontSize: 10, color: C.dim, marginTop: 2 }}>{c.article}{c.page ? ' · p. ' + c.page : ''}{c.status === 'OCR' ? ' · OCR' : ''}</div> : null}
                      </td>
                    );
                  })}
                </tr>
              ))}</tbody>
            </table>
          </div>
          {cell ? (
            <div style={{ border: '1px solid ' + C.accent, padding: '10px 12px', marginTop: 10, fontSize: 12, color: C.text }}>
              <div style={{ fontWeight: 700 }}>{cell.term} - {cell.round.title}</div>
              <div style={{ color: C.dim, marginBottom: 6 }}>{cell.round.document}</div>
              {(cell.c.items && cell.c.items.length ? cell.c.items : [cell.c]).map((it, i) => (
                <div key={i} style={{ marginBottom: 6 }}>
                  <div>{it.value}</div>
                  <div style={{ color: C.dim }}>{it.article}{it.page ? ', page ' + it.page : ''}{it.status === 'OCR' ? ' (read from the scan)' : ''}</div>
                  {it.quote ? <div style={{ fontStyle: 'italic', borderLeft: '3px solid ' + C.accent, paddingLeft: 8, marginTop: 2 }}>"{it.quote}"</div> : null}
                </div>
              ))}
              <button className="btn btn-secondary btn-sm" onClick={() => setCell(null)}>Close</button>
            </div>
          ) : null}
          {(S6.notes || []).length ? (
            <details style={{ marginTop: 10 }}>
              <summary style={{ cursor: 'pointer', color: C.dim, fontSize: 12 }}>How this was read, and what the agreements get wrong about themselves ({S6.notes.length} notes)</summary>
              <ul style={{ fontSize: 11, color: C.dim, paddingLeft: 18 }}>{S6.notes.map((n, i) => <li key={i} style={{ marginBottom: 4 }}>{n}</li>)}</ul>
            </details>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
